/* ============================================================
   Kasım paketleri bölümü (sections/package-kasim.liquid)
   ------------------------------------------------------------
   - [data-fos-countdown="<epoch ms>"] kutularını saniyede bir günceller.
   - Açık görünümün sayacı (data-ends) sıfırlanınca sayfayı yenilemeden
     Kapandı görünümüne geçer: [data-view="open"] gizlenir,
     [data-view="closed"] görünür. Kart butonları o anda kaybolduğu için
     builder da açılamaz; kasadaki fonksiyon aynı an kapanır.
   - Builder kart tıklaması package-landing.js'te ([data-fos-pc-combo]).
   ============================================================ */
(function () {
  'use strict';

  if (window.fosKasimInitialized) {
    return;
  }
  window.fosKasimInitialized = true;

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function renderClock(el, now) {
    var target = parseInt(el.getAttribute('data-fos-countdown'), 10) || 0;
    var left = Math.max(0, Math.floor((target - now) / 1000));
    var parts = {
      d: Math.floor(left / 86400),
      h: Math.floor((left % 86400) / 3600),
      m: Math.floor((left % 3600) / 60),
      s: left % 60
    };
    Object.keys(parts).forEach(function (unit) {
      var cell = el.querySelector('[data-unit="' + unit + '"]');
      if (cell) {
        cell.textContent = pad(parts[unit]);
      }
    });
  }

  function setState(section, state) {
    if (section.getAttribute('data-state') === state) {
      return;
    }
    section.setAttribute('data-state', state);
    section.querySelectorAll('[data-view]').forEach(function (view) {
      view.hidden = view.getAttribute('data-view') !== state;
    });
  }

  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-fos-countdown]').forEach(function (el) {
      renderClock(el, now);
    });
    document.querySelectorAll('[data-fos-kasim]').forEach(function (section) {
      var ends = parseInt(section.getAttribute('data-ends'), 10) || 0;
      if (ends > 0 && now >= ends) {
        setState(section, 'closed');
      }
    });
  }

  /* ----- haber ver formu → Klaviyo listesi -----
     Klaviyo'nun herkese açık abonelik uç noktası (yalnız company id ister,
     gizli anahtar yok). Alan e-posta ya da telefon (TR numarası, +90'a
     çevrilir). Onay listeye abonelikle verilir; bu revizyonda profilde
     ayrı bir subscriptions alanı kabul edilmiyor (400 döner). */
  function normalizePhone(raw) {
    var digits = raw.replace(/[^0-9+]/g, '');
    if (/^\+\d{10,15}$/.test(digits)) return digits;
    digits = digits.replace(/\D/g, '');
    if (/^90\d{10}$/.test(digits)) return '+' + digits;
    if (/^0\d{10}$/.test(digits)) return '+9' + digits;
    if (/^5\d{9}$/.test(digits)) return '+90' + digits;
    return null;
  }

  function subscribe(form) {
    var input = form.querySelector('input[name="contact"]');
    var msg = form.querySelector('[data-msg]');
    var btn = form.querySelector('button[type="submit"]');
    var value = (input.value || '').trim();
    var profile = {};
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      profile.email = value;
    } else {
      var phone = normalizePhone(value);
      if (!phone) {
        msg.textContent = form.getAttribute('data-invalid');
        return;
      }
      profile.phone_number = phone;
    }
    btn.disabled = true;
    msg.textContent = '';
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(form.getAttribute('data-company')), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.getAttribute('data-source') || undefined,
            profile: { data: { type: 'profile', attributes: profile } }
          },
          relationships: { list: { data: { type: 'list', id: form.getAttribute('data-list') } } }
        }
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('subscribe ' + res.status);
        form.classList.add('is-done');
        input.value = '';
        msg.textContent = form.getAttribute('data-ok');
      })
      .catch(function () {
        msg.textContent = form.getAttribute('data-error');
      })
      .then(function () {
        btn.disabled = false;
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-fos-kasim-signup]');
    if (!form) return;
    e.preventDefault();
    subscribe(form);
  });

  function start() {
    if (!document.querySelector('[data-fos-countdown], [data-fos-kasim]')) {
      return;
    }
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
